import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEPersonalOverviewCardActions = {
  initPePersonalOverviewCard: ({ commit }) => {
    commit('setPePersonalOverviewCardLock', true)
  },
  PePersonalOverviewCardUpdate: async ({ commit, getters }, { section }) => {
    const party = getters.peParty

    const overview = {
      party_id: section.party_id || party.id,
      experienced_labor_violation_us: section.experienced_labor_violation_us,
      fear_returning_home_country: section.fear_returning_home_country,
      forced_sexual_encounters: section.forced_sexual_encounters,
      forced_to_work_against_will: section.forced_to_work_against_will,
      hrifa_eligibility: section.hrifa_eligibility,
      mistreated_by_coyote_in_transit: section.mistreated_by_coyote_in_transit,
      nacara_eligibility: section.nacara_eligibility,
      national_of_tps_designated_country: section.national_of_tps_designated_country,
      notes: section.notes,
      suffered_mental_harm: section.suffered_mental_harm,
      suffered_physical_harm_home_country: section.suffered_physical_harm_home_country,
      us_military_service: section.us_military_service,
      victim_of_dv_abuse_by_relative_childhood: section.victim_of_dv_abuse_by_relative_childhood,
      victim_of_dv_us_usc_relative: section.victim_of_dv_us_usc_relative,
      victim_of_ucrime_us: section.victim_of_ucrime_us,
    }

    const action = !section.id
      ? axiosRequest.post('/party_characteristics', { overview })
      : axiosRequest.patch(`/party_characteristics/${section.id}`, { overview })

    return action.
      then(({ data }) => {
        const overview = data || {}

        commit('setPePersonalOverviewCardLock', true)
        commit('pePatchParty', {
          overview: overview,
        })

        return data
      }).
      catch(handleError)
  },
}

export const PEPersonalOverviewCardMutations = {
  setPePersonalOverviewCardLock: (state, lock) => {
    Vue.set(state.partyEdit.partySections, 'PersonalOverviewCard', lock)
  },
}

export const PEPersonalOverviewCardGetters = {
  PePersonalOverviewCardLock: state => state.partyEdit.partySections.PersonalOverviewCard,
}
